import * as XLSX from 'xlsx';

export class ExcelHelper {
  public static exportAsExcel(
    tableData: any[][],
    fileName: string,
    settings?: {
      cols?: XLSX.ColInfo[];
      merges?: XLSX.Range[];
    },
  ): void {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(tableData);
    if (settings && settings.cols) {
      ws['!cols'] = settings.cols;
    }
    if (settings && settings.merges) {
      ws['!merges'] = settings.merges;
    }

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);
  }
}
